export default __webpack_public_path__ + "static/BOX-09f654236f31a52062dbf3d7b215d855.png";